import { createTheme } from '@mui/material/styles';

const baseTheme = createTheme({
    palette: {
        primary: {
            main: '#4B69F1',
            dark: '#4B69F1',
            light: '#4B69F1',
            contrastText: '#FEFEFE',
        },
        secondary: {
            main: '#636363',
            dark: '#223E58',
            light: '#52C0BE',
            contrastText: '#401A4E',
        },
        error: {
            main: '#F34236',
            dark: '#D22E2E',
            light: '#FA6976',
            contrastText: '#FEFEFE',
        },
        warning: {
            main: '#FE9700',
            dark: '#F47B00',
            light: '#FF835C',
            contrastText: '#FEFEFE',
        },
        info: {
            main: '#1F95F2',
            dark: '#1875D1',
            light: '#63B4F5',
            contrastText: '#FEFEFE',
        },
        success: {
            main: '#2CA670',
            dark: '#378D3B',
            light: '#96EAC4',
            contrastText: '#FEFEFE',
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                contained: {
                    backgroundColor: '#4B69F1',
                    color: '#FEFEFE',
                    '&:hover': {
                        backgroundColor: '#3A4FB1',
                    },
                    '&:focus': {
                        backgroundColor: '#3A4FB1',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#CDCBCA',
                        color: '#FFFFFF',
                    },
                },
                outlined: {
                    color: '#000',
                    '&:hover': {
                        borderColor: '#404144',
                        backgroundColor: '#4B69F11A',
                    },
                    '&:focus': {
                        backgroundColor: '#4B69F133',
                        border: "4px solid #4B69F11F"
                    },
                    '&.Mui-disabled': {
                        backgroundColor:  '#CDCBCA',
                        color: '#FFFFFF',
                    },
                },
            },
        },
  },
});

export { baseTheme };
